import type { ComponentChildren } from "preact";
import { Link } from "wouter-preact";
import { CONTACT_EMAIL } from "../lib/contact";
import { LEGAL } from "../lib/legal";
import { Disclaimer } from "./Disclaimer";
import { Wordmark } from "./Wordmark";

/**
 * Shared chrome for the static legal documents (`/terms`, `/privacy`).
 *
 * Kept outside `RequireAuth` so the pages are readable while signed out, and
 * deliberately free of app state (history, session) so they render instantly.
 */
export function LegalPage({
  title,
  children,
}: {
  title: string;
  children: ComponentChildren;
}) {
  return (
    <div class="view">
      <header class="topbar content">
        <div class="topbar__left">
          <Wordmark href="/ask" />
        </div>
        <Link href="/" class="btn btn--ghost">
          Back to app
        </Link>
      </header>

      <main class="legal content">
        <p class="legal__eyebrow">Legal</p>
        <h1 class="legal__title">{title}</h1>
        <p class="legal__meta">Last updated {LEGAL.updated}</p>

        <div class="legal__prose">{children}</div>

        <footer class="legal__foot">
          <nav class="legal__nav" aria-label="Legal documents">
            <Link href="/terms">Terms of Service</Link>
            <Link href="/privacy">Privacy Policy</Link>
          </nav>
          <p>
            Questions about this document? Email{" "}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
          <Disclaimer />
        </footer>
      </main>
    </div>
  );
}
